import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { FormInstance } from "antd/lib/form";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";
import { IStore } from "../../../core/model/runtime/state/Store";
import TranslationInputField from "../../../core/ui/components/TranslationInputField";

const FormFields = {
  ID: "id",
  NAME: "name",
  INDEX_TYPE_GROUP_ID: "indexTypeGroupId",
  ORGANISATION_CATEGORY_ID: "organisationIndexCategoryId",
  ORGANISATION_ID: "organisationId",
  VALID: "valid",
  HARMONIZED: "harmonized",
  PARENT_ID: "parentId"
};

const OrganisationIndexGroupForm = ({
  translate,
  form,
  rowData,
  indexTypeGroupId,
  organisationId,
  categoryId,
  parentId,
  store
}: {
  translate: any;
  form: FormInstance;
  rowData?: IOrganisationIndexGroup;
  indexTypeGroupId: number;
  categoryId: number;
  organisationId: number;
  parentId: number;
  store: IStore;
}) => {
  const getInitialValues = () => {
    if (rowData && Object.keys(rowData).length > 0) {
      if (rowData.nameTranslations.length > 0) {
        return rowData.nameTranslations;
      } else {
        return [
          {
            nameTranslation: rowData.name,
            languageId: store.getState<any>().selectedLanguage.id,
            valid: true
          }
        ];
      }
    } else {
      return [
        {
          nameTranslation: "",
          languageId: store.getState<any>().selectedLanguage.id,
          valid: true
        }
      ];
    }
  };
  form.setFieldsValue({
    parentId: parentId,
    indexTypeGroupId,
    organisationIndexCategoryId: categoryId,
    organisationId,
    nameTranslations: getInitialValues()
  });
  return (
    <Form
      layout={"vertical"}
      form={form}
      initialValues={{
        nameTranslations: getInitialValues()
      }}
    >
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.INDEX_TYPE_GROUP_ID}
        initialValue={rowData?.indexTypeGroupId ?? indexTypeGroupId}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.VALID}
        initialValue={rowData?.valid ?? true}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.ORGANISATION_ID}
        initialValue={rowData?.organisationId ?? organisationId}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.ORGANISATION_CATEGORY_ID}
        initialValue={rowData?.organisationIndexCategoryId ?? categoryId}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.PARENT_ID}
        initialValue={parentId}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>

      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col lg={24} sm={24} xs={24}>
          <TranslationInputField
            translate={translate}
            organisationId={organisationId}
            translationObjectIdFieldName={"organisationIndexGroupId"}
            store={store}
            form={form}
          />
        </Col>
      </Row>
      <Col xs={24} sm={24}>
        <Form.Item
          label={translate("editors.organisation_index_groups.harmonized")}
          className={"png-form-item-horizontal-checkbox mb-0"}
          name={FormFields.HARMONIZED}
          valuePropName={"checked"}
          initialValue={rowData?.harmonized ?? true}
        >
          <Checkbox />
        </Form.Item>
      </Col>
    </Form>
  );
};

export default OrganisationIndexGroupForm;
